export const tiers = [
  {
    id: 1,
    title: "Free",
    subheader: "Starter",
    price: "0",
    description: ["Execute Trade on Dummy Account", "No real Transactions"],
    AccountType: "Demo",
    isSubscribed: false,
  },
  {
    id: 2,
    title: "Pro",
    subheader: "Most popular",
    price: "15",
    description: ["Execute Trade on Trading Account", "Real Transactions"],
    AccountType: "Trading",
    isSubscribed: true,
  },
];

export const billingHistory = {
  date: "January 1, 2023",
  amount: 19.99,
  status: "Paid",
};

export const getCurrentPlan = () => {
  const currentPlan = tiers.find((record) => record.isSubscribed === true);
  if (currentPlan) {
    return currentPlan;
  } else {
    return null;
  }
};
export const changeCurrentPlan = (currentPlan) => {
  if (currentPlan) {
    const updatedTiers = tiers.map((record) => {
      if (record.isSubscribed) {
        return { ...record, isSubscribed: false };
      }
      return record;
    });
    return updatedTiers;
  } else {
    return null;
  }
};
export const changePlan = () => {
  const updatedTiers = tiers.map((record) => {
    if (record.isSubscribed) {
      return { ...record, isSubscribed: false };
    }
    return record;
  });
  return updatedTiers;
};
export const getAllPlans = () => {
  return tiers;
};
